// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-text-field{position:relative}.copy-text-field__content{align-items:center;background-color:var(--border-color);border:1px solid var(--border-color);border-radius:8px;display:flex;gap:8px;padding:8px 12px;width:100%}.copy-text-field__value{color:rgba(0,0,0,.87);flex:1;font-size:16px;line-height:1.5;min-width:0;word-wrap:anywhere;word-break:break-word}.copy-text-field__action{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
